import React, { useEffect, useState } from "react";
import { DataTable } from "@MASTER";
import useLogics from "./logics";
import { ReportEndpoints } from "@REPORTS";
import { useGET } from "@API2";
import Papa from "papaparse";
import { Row, Select, Col } from "antd";
const { Option } = Select;
const Table = ({ filters }) => {
  const logics = useLogics();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    pageSizeOptions: [10, 25, 50, 100],
    showSizeChanger: true,
  });
  const [reportData, setReportData] = useState(null);
  const [selectedCity, setSelectedCity] = useState(null);
  const [selectedTown, setSelectedTown] = useState(null);
  const { data, loading, mutate } = useGET(
    `${ReportEndpoints.deliveryAreas}?`,
    new URLSearchParams(filters).toString()
  );
  useEffect(() => {
    if (!data || data.length === 0) return;

    const result = Papa.parse(data, {
      header: true,
      skipEmptyLines: true,
    });
    setReportData(result.data);
  }, [data]);
  let cities, towns, uniqueTowns;
  if (reportData?.length > 0) {
    cities = [...new Set(reportData.map((r) => r.CITY_NAME))];
    towns = reportData
      .filter((r) => r.CITY_NAME === selectedCity)
      .map((r) => r.TOWN_NAME);
    uniqueTowns = [...new Set(towns)];
  }

  const handleTableChange = (paginationInfo) => {
    console.log(paginationInfo);
    setPagination({
      ...pagination,
      current: paginationInfo.current,
      pageSize: paginationInfo.pageSize,
    });
  };

  useEffect(() => {
    setPagination((prev) => ({ ...prev, current: 1 }));
  }, [selectedCity, selectedTown]);

  return (
    <div style={{ width: "calc(100vw - 400px)" }}>
      {reportData && (
        <Row gutter={(16, 16)}>
          <Col>
            <Select
              placeholder="Şehir Seçiniz"
              style={{ width: 180 }}
              value={selectedCity}
              onChange={(value) => {
                setSelectedCity(value);
                setSelectedTown(null);
              }}
              allowClear
            >
              {cities?.map((city) => (
                <Option key={city} value={city}>
                  {city}
                </Option>
              ))}
            </Select>

            {/* İlçe Seçimi */}
          </Col>
          <Col>
            <Select
              placeholder="İlçe Seçiniz"
              style={{ width: 180 }}
              value={selectedTown}
              onChange={setSelectedTown}
              disabled={!selectedCity}
              allowClear
            >
              {uniqueTowns?.map((town) => (
                <Option key={town} value={town}>
                  {town}
                </Option>
              ))}
            </Select>
          </Col>
        </Row>
      )}
      <Row gutter={[16, 16]} style={{ marginTop: 16 }}>
        <Col span={24}>
          <DataTable
            name="Detaylı Dağıtım Alanları"
            {...logics}
            dataSource={
              // Eğer şehir veya ilçe seçiliyse tabloyu filtreleyelim
              reportData?.filter((r) => {
                const matchCity = selectedCity
                  ? r.CITY_NAME === selectedCity
                  : true;
                const matchTown = selectedTown
                  ? r.TOWN_NAME === selectedTown
                  : true;
                return matchCity && matchTown;
              })
            }
            rowKey="barcode"
            loading={loading}
            pagination={{
              ...pagination,

              showTotal: (total, range) =>
                `${range[0]}-${range[1]} arası gösteriliyor • Toplam ${total} kayıt`,
            }}
            scroll={{ x: "max-content" }}
            sticky={{ offsetHeader: 0, offsetScroll: 0 }}
            bordered
            onChange={handleTableChange}
            mutate={mutate}
          />
        </Col>
      </Row>
    </div>
  );
};

export default Table;
